
// the object.keys code below will add a getLabel function onto each of these that you pass a caseType into and it returns the proper label
// Add more labels if it's based on different types of cases.
export const CaseFieldLabels = {
  // generic
  Inspector: { label: "Field Rep" },
  SurveyType: { label: "Report Type" }, 

  // based on case type
  PolicyNumber: { insurance: "Policy Number", valuation: "Loan #" },
  PolicyHolder: { insurance: "Policyholder", valuation: "Borrower" },
  Customer: { insurance: "Customer", valuation: "Lender/Client" },
};

// getLabel function will return the lable above for the case type
// Example: CaseFieldLabels.PolicyHolder.getLabel(caseType);
// Example: CaseFieldLabels.SurveyType.getLabel();
Object.keys(CaseFieldLabels).forEach(k => CaseFieldLabels[k].getLabel = (caseType) => CaseFieldLabels[k][caseType] || CaseFieldLabels[k].label);
